import { render, staticRenderFns } from "./AjustesConsol.vue?vue&type=template&id=3406c805&scoped=true"
import script from "./AjustesConsol.vue?vue&type=script&lang=js"
export * from "./AjustesConsol.vue?vue&type=script&lang=js"
import style0 from "./AjustesConsol.vue?vue&type=style&index=0&id=3406c805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406c805",
  null
  
)

export default component.exports